import { Link } from "react-router-dom"
import "./buttonAn.css"
export default function SecondBtn() {
    return (
        <>
            <Link to="/Gallery" class="sageAnime-btn sageAnime-cutter">Explore More...</Link>
        </>
    )
}